import { create, StoreApi, UseBoundStore } from "zustand";

export interface ModalState<T> {
	isOpen: boolean;
	open: () => void;
	close: () => void;
	isNew?: boolean;
	item?: T;
	openWithItem: (item: T, isNew?: boolean) => void;
}

interface Props<T> {
	beforeClose?: () => void;
	isOpenable?: (item?: T) => boolean;
}

export function createModal<T>(
	props: Props<T>
): UseBoundStore<StoreApi<ModalState<T>>> {
	const { beforeClose, isOpenable } = props;

	return create<ModalState<T>>((set) => ({
		isOpen: false,
		open: () => set({ isOpen: true }),
		close: () => {
			void beforeClose?.();
			set({ isOpen: false, item: undefined, isNew: undefined });
		},
		openWithItem: (item, isNew) => {
			if (isOpenable?.(item) === false) return;
			set({ item, isOpen: true, isNew });
		},
	}));
}
